const KEY = 'sourceCartTokenBeforeTinkoff';

const TTL = 15 * 60 * 1000;

interface StoredSourceCart {
  token: string;
  ts: number;
}

export const saveTinkoffSourceCart = (token: string): void => {
  if (!token) {
    return;
  }
  try {
    const payload: StoredSourceCart = { token, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (e) {
    console.log(e);
  }
};

export const clearTinkoffSourceCart = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    console.log(e);
  }
};

export const takeTinkoffSourceCart = (): string => {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(KEY);
  } catch (e) {
    console.log(e);
    return '';
  }
  if (!raw) {
    return '';
  }

  clearTinkoffSourceCart();

  try {
    const parsed = JSON.parse(raw) as StoredSourceCart | string;
    if (typeof parsed !== 'object' || !parsed?.token || !parsed?.ts) {
      return '';
    }
    return Date.now() - parsed.ts > TTL ? '' : parsed.token;
  } catch (e) {
    console.log(e);
    return '';
  }
};
